import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ReportFiltersService = {

    // NATURES
    dispatchNatures: async () => axios.get(API_URL + "/nature/get/dispatchNatures").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    dispatchNaturesGroups: async () => axios.get(API_URL + "/nature/get/dispatchNatureGroups").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    natureActions: async () => axios.get(API_URL + "/nature/getNature/getActionsNatures").then(({ data }) => data.map(d => ({ value: d.id, label: d.label }))).catch((err) => { throw err }),

    natureGroups: async () => axios.get(API_URL + "/nature/getNature/groups").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boResponsibleReasons: async () => axios.get(API_URL + "/nature/get/getBoResponsibleReasons").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // ADDRESSES
    channelNames: async () => axios.get(API_URL + "/attendance_sequence/channelNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    streetNames: async () => axios.get(API_URL + "/street/get/streetNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    placeNames: async () => axios.get(API_URL + "/place/getPlace/placeNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    neighborhood: async () => axios.get(API_URL + "/neighborhood/get/names").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allSectors: async () => axios.get(API_URL + "/areaLayer/get/allSectors").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    placeTypes: async () => axios.get(API_URL + "/place/getPlace/types").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // OCCURRENCES
    occurrencesCityFact: async () => axios.get(API_URL + "/locations/getOccurrencesCityFact").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    occurrencesDetailsNatures: async () => axios.get(API_URL + "/nature/getNature/getOccurrencesDetailsNatures").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    occurrenceVehicleClassification: async () => axios.get(API_URL + "/occurrence_associated_vehicles/getOccurrenceVehicleClassification").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // BO
    boStatus: async () => axios.get(API_URL + "/bos/get/status").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boXRayResponsible: async () => axios.get(API_URL + "/user-agents/getBoXRayLeader").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boXRayReasons: async () => axios.get(API_URL + "/nature/getNature/getBoXRaySpecificNatures").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boXRayNeighborhoods: async () => axios.get(API_URL + "/locations/boNeighborhood").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boXRayStreets: async () => axios.get(API_URL + "/locations/boStreet").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boXRayConditions: async () => axios.get(API_URL + "/user-agents/getBoConditions").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boValidatorLogin: async () => axios.get(API_URL + "/user/getBoValidatorLogin").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boValidatorName: async () => axios.get(API_URL + "/user/getBoValidatorName").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    boValidatorCPF: async () => axios.get(API_URL + "/user/getBoValidatorCpf").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    // APPREHENSIONS
    apprehensionsTypes: async () => axios.get(API_URL + "/apprehensions/types").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    apprehensionsSubtypes: async () => axios.get(API_URL + "/apprehensions/subtypes").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // USERS
    leadersIdentification: async () => axios.get(API_URL + "/user/get/leadersIdentification").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allowedOnly: async () => axios.get(API_URL + "/user/get/allowedOnly").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allTeams: async () => axios.get(API_URL + "/user/get/allTeams").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    getTeams: async () => axios.get(API_URL + "/team/get/all").then(({ data }) => data).catch((err) => { throw err }),

    allEffectiveNameWar: async () => axios.get(API_URL + "/reports/effective_training/allNameWar").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allEffectiveNames: async () => axios.get(API_URL + "/reports/effective_training/allNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allEffectiveCpf: async () => axios.get(API_URL + "/reports/effective_training/allCpfs").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    occurrenceDetailsCondition: async () => axios.get(API_URL + "/individual/get/getOccurrencesDetailsCondition").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    occurrenceDetailsNeighborhood: async () => axios.get(API_URL + "/locations/getOccurrencesDetailsNeighborhood").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    getActivityJournalTeams: async () => axios.get(API_URL + "/team/get/getActivityJournalTeams").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    getActivityJournalResponsible: async () => axios.get(API_URL + "/user/get/userIdentification").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    dispatchUsers: async () => axios.get(API_URL + "/user/getUser/dispatchUsers").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    garrisonTeams: async () => axios.get(API_URL + "/user/get/garrisonTeams").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    getAbsenceReason: async () => axios.get(API_URL + "/agent_absences/getReasons").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    vehiclePassagesOperationGroups: async () => axios.get(API_URL + "/group/options/all").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // VEHICLES
    allVehicles: async () => axios.get(API_URL + "/vehicle/get/all").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    getVehicles: async () => axios.get(API_URL + "/fleet_supplies/get-vehicles").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    fleetSuppliesPrefix: async () => axios.get(API_URL + "/fleet_supplies/vehicle-prefix").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    fleetSuppliesGasStation: async () => axios.get(API_URL + "/fleet_supplies/gas-station").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // LANES
    pclNames: async () => axios.get(API_URL + "/traffic_flow_route/getAllPclNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    alarmPcl: async () => axios.get(API_URL + "/alarm_statistics/getPclNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    vehicleStayPCLs: async () => axios.get(API_URL + "/traffic_vehicle_stay/pcl/getAllPclNames").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // ALARMS
    alarmQuestions: async () => axios.get(API_URL + "/alarm_statistics/getAlarmQuestions").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    alarmEventSource: async () => axios.get(API_URL + "/alarm_list/get/sources").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // MATERIAL
    allMaterials: async () => axios.get(API_URL + "/materials/options/all").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allMaterialStorages: async () => axios.get(API_URL + "/material-storages/options/all").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    allMaterialGroups: async () => axios.get(API_URL + "/material-groups/options/all").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // ENCOUNTER
    encounterAgents: async () => axios.get(API_URL + "/user-agents/encounterAgents").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),


    // SOLICITATIONS
    solicitationUsers: async () => axios.get(API_URL + "/user/get/getSolicitationEcapUsers").then(({ data }) => data).catch((err) => { throw err }),

    solicitationNatures: async () => axios.get(API_URL + "/nature/getNature/getSolicitationSpecificNatures").then(({ data }) => data).catch((err) => { throw err }),

    solicitationOrganizations: async () => axios.get(API_URL + "/user/get/getSolicitationOrganizations").then(({ data }) => data).catch((err) => { throw err }),


    // SOS
    sosActionUsers: async () => axios.get(API_URL + "/user/get/sosActionsUsers").then(({ data }) => data).catch((err) => { throw err }),

    sosProtectionPrograms: async () => axios.get(API_URL + "/sos/allProtectionProgram").then(({ data }) => data.map(d => ({ value: d.id, label: d.text }))).catch((err) => { throw err }),

    sosCitizens: async () => axios.get(API_URL + "/sos/allCitizens").then(({ data }) => data).catch((err) => { throw err }),

    sosResponsible: async () => axios.get(API_URL + "/sos_history/allResponsibles").then(({ data }) => data).catch((err) => { throw err }),

    sosCreatedBy: async () => axios.get(API_URL + "/sos_history/allCreators").then(({ data }) => data).catch((err) => { throw err }),

};

export default ReportFiltersService;